import { getHumanReadableDateTime } from '@Utils/helpers/stringHelpers';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Styles from './EntityDrawer.scss';

const EntityDrawerProcessResultRow = (props) => {
    const { processData } = props;

    return (
        <div className={cx(Styles.baseAttributeRow, Styles.attributeRowQc)}>
            <div className={Styles.attributeRowGeneric}>
                <div className={Styles.attributeRowDash} />
                <div className={Styles.attributeRowKey}>
                    <span>{processData.process_name}</span>
                </div>
                <div className={Styles.attributeRowValue}>
                    <span>
                        {processData.result === null ? '-' : processData.result}
                    </span>
                </div>
            </div>
            <div className={Styles.attributeRowGeneric}>
                <div className={Styles.attributeRowDash} />
                <div className={Styles.attributeRowKey}>
                    <span>
                        {getHumanReadableDateTime(processData.create_time)}
                    </span>
                </div>
                <div className={Styles.attributeRowValue} />
            </div>
        </div>
    );
};

EntityDrawerProcessResultRow.propTypes = {
    processData: PropTypes.any,
};
export default EntityDrawerProcessResultRow;
